import { gql } from "@apollo/client";
import { attachmentFragment } from "modules/CommonFragments";

export const defaultOutcomeFragment = {
  defaultOutcome: gql`
    fragment defaultOutcomeItem on BehaviourDefaultOutcome {
      id
      appliedActions {
        id
        action {
          id
          title
          state
          metadata
        }
      }
      accessibilityMap {
        id
        type
        shouldNotify
        entityId
        users {
          id
          firstName
          middleName
          lastName
          profileImage
          type
          ... on Staff {
            prefix
            suffix
            preferredName
            pronouns
            curriculumPrograms @include(if: $includeUserCurriculums) {
              id
            }
          }
        }
        details {
          id
          type
          value
        }
      }
      subCategory {
        id
        name
      }
      severity {
        id
        name
        level
        color
      }
      description
      confidentialNote
      attachments {
        ...attachmentItem
      }
      confidentialAttachments {
        ...attachmentItem
      }
    }
    ${attachmentFragment.attachment}
  `,
};
